<template>
  <div class="login-wrapper">
    <div class="content-wrapper">
      <div class="content">
        <div class="content-head">
          <div class="text">{{ titleText }}</div>
        </div>
        <div class="form">
          <van-form>
            <van-field
              class="form-item"
              v-model="form.nickName"
              required
              label="学生姓名"
              placeholder="请输入学生姓名"
            />
            <van-field
              class="form-item"
              v-model="form.mobile"
              type="tel"
              required
              label="手机号"
              placeholder="请输入手机号"
              name="validator"
            />
            <van-field
              class="form-item"
              v-model="form.smsCode"
              required
              center
              clearable
              label="验证码"
              placeholder="请输入验证码"
            >
              <template #button>
                <van-button size="small" type="primary" @click="getSmsCode">{{
                  smsText
                }}</van-button>
              </template>
            </van-field>
          </van-form>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="left">
        <div class="text">应付：</div>
        <div class="price">
          <div class="icon">￥</div>
          <div class="text">{{ price }}</div>
        </div>
      </div>
      <div class="btn" @click="submit">支付</div>
    </div>
  </div>
</template>
<script>
import { Form, Field, Button, Toast } from "vant"
import { smsCode, login, orderSave, getPaySign, getopenid } from "../../request/api/user"
import { ERROR_OK } from "../../request/http"
import wx from "weixin-js-sdk"
import { getAppId, getSdk } from "../../request/api/study"
export default {
  data () {
    return {
      show: false,
      form: {
        mobile: "",
        smsCode: "",
        nickName: "",
        classId: "",
      },
      list: [],
      isSend: false,
      countdown: 60,
      currentIndex: "",
      imgUrl: "",
      isSubmit: false,
      userId: '',
      prepayId: '',
      paySign: '',
      code: '',
      distributorId: '',
      distributorType: ''
    }
  },
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
  computed: {
    smsText () {
      return this.isSend ? `${this.countdown}s重新获取` : "发送验证码"
    },
    isMobile () {
      return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.form.mobile)
    },
    titleText () {
      let text = ""
      if (this.channelType == 1) {
        text = "思维启蒙课"
      } else {
        text = "少儿数独入门课"
      }
      return text
    },
    price () {
      let price = 0
      if (this.channelId == 2) {
        price = 299
      } else {
        price = 199
      }
      return price
    }
  },
  created () {
    this.getWxCode()
    this.appId = 'wx3dcc8b8f8d8bf78b'
    this.channelId = this.$route.query.channelId || 2
    this.channelType = this.$route.query.channelType || 1
    let classId = this.$route.query.classId
    if (classId != 174) {
      classId = 171
    }
    this.form.classId = classId
    if (
      navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
      "micromessenger"
    ) {
      this.getAppIdInfo()
    }
  },
  methods: {
    getUrlParam (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    getWxCode () {
      let code = this.getUrlParam("code")
      getopenid({ code }).then(res => {
        this.openid = res.data.openid
      })
    },
    validator (val) {
      return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val)
    },
    async getSmsCode () {
      console.log(333)
      if (!this.isMobile || this.isSend) {
        return
      }
      console.log(555)
      let { code } = await smsCode({
        mobile: this.form.mobile
      })
      if (code === ERROR_OK) {
        this.isSend = true
        this.setTime()
      } else {
        Toast.fail({
          type: "fail",
          message: "验证码发送失败，请稍后再试",
          duration: 1000
        })
      }
    },
    setTime () {
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          clearInterval(this.timer)
          this.countdown = 60
          this.isSend = false
        }
        this.countdown--
      }, 1000)
    },
    async bindMobile () {
      // this.openid = this.openid
      let { code, data, msg } = await login({
        openid: this.openid,
        ...this.form
      })
      if (code === ERROR_OK) {
        this.userId = data.userId
        this.distributorType = data.distributorType
        this.distributorId = data.distributorId
      } else {
        Toast.fail({
          type: "fail",
          message: msg,
          duration: 1000
        })
        return
      }
    },
    async orderSave () {
      let { code, data, msg } = await orderSave({
        openid: this.openid,
        userId: this.userId,
        classId: this.form.classId
      })
      if (code === ERROR_OK) {
        this.prepayId = data.prepayId
      } else {
        Toast.fail({
          type: "fail",
          message: msg,
          duration: 1000
        })
        return
      }
    },
    async _getPaySign () {
      let timestamp = Math.floor(+new Date() / 1000) + ''
      let nonceStr = timestamp + "1"
      let { code, data } = await getPaySign({
        appId: this.appId,
        timestamp,
        nonceStr,
        package: `prepay_id=${this.prepayId}`
      })
      if (code === ERROR_OK) {
        this.paySign = data.paySign
        wx.invoke('getBrandWCPayRequest', {
          appId: this.appId,
          timeStamp: timestamp,
          nonceStr,
          package: `prepay_id=${this.prepayId}`,
          "signType": "RSA",     //微信签名方式：     
          "paySign": this.paySign
        },
          res => {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              this.$router.replace({
                name: 'buySuccess',
                query: {
                  distributorId: this.distributorId,
                  distributorType: this.distributorType
                }
              })
            }
          })
      }
    },
    async submit () {
      for (let key in this.form) {
        if (!this.form[key]) {
          Toast.fail({
            type: "fail",
            message: "请输入基本信息",
            duration: 1000
          })
          return
        }
      }
      if (this.isSubmit) {
        return
      }
      await this.bindMobile()
      await this.orderSave()
      await this._getPaySign()
      this.isSubmit = true
      setTimeout(() => {
        this.isSubmit = false
      }, 1500)
    },
    async getAppIdInfo () {
      let { code, data } = await getAppId({})
      if (code === ERROR_OK) {
        const appId = data.appId
        let timestamp = Math.floor(+new Date() / 1000)
        let nonceStr = timestamp + "1"
        let url = window.location.href.split("#")[0]
        let { code: sdkCode, data: sdkData } = await getSdk({
          timestamp,
          nonceStr,
          url,
          appId
        })
        if (sdkCode === ERROR_OK) {
          const signature = sdkData.signature
          await wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          })
          wx.error(res => {
            console.log(res)
          })
          wx.ready(() => {
            this.updateAppMessageShareData()
            this.updateTimelineShareData()
          })
        }
      }
    },
    updateAppMessageShareData () {
      let title =
        "你的朋友送你一周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      if (this.channelId == 2) {
        title = "你的朋友送你双周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      }
      let desc = "做好思维启蒙，让孩子爱学习，会思考"
      let imgUrl =
        "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/H6r2fkdwK4hHCjA5Ts6yTYPCEcfwcG5R.png"
      if (this.channelId == 2) {
        imgUrl =
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/pd6yjBzne4BNSK8BW8ZDFrGCa4HTXzZz.png"
      }
      let link = `http://jimuaike.com/wap/#/exchange?openid=${this.openid}&channelId=${this.channelId}`
      wx.updateAppMessageShareData({
        title,
        desc,
        link,
        imgUrl,
        success () {
          console.log("分享成功")
        }
      })
    },
    updateTimelineShareData () {
      let title =
        "你的朋友送你一周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      if (this.channelId == 2) {
        title = "你的朋友送你双周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      }
      let desc = "做好思维启蒙，让孩子爱学习，会思考"
      let imgUrl =
        "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/H6r2fkdwK4hHCjA5Ts6yTYPCEcfwcG5R.png"
      if (this.channelId == 2) {
        imgUrl =
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/pd6yjBzne4BNSK8BW8ZDFrGCa4HTXzZz.png"
      }
      let link = `http://jimuaike.com/wap/#/exchange?openid=${this.openid}&channelId=${this.channelId}`
      wx.updateTimelineShareData({
        title,
        desc,
        link,
        imgUrl,
        success () {
          console.log("分享成功")
        }
      })
    }
  }
};
</script>
<style lang="less">
.van-cell {
  padding: 10px 6px !important;
}
.van-cell--required::before {
  left: 0px;
}
.van-cell:last-child::after {
  display: block;
}
.van-button--primary {
  padding: 0 0;
  background-color: transparent;
  border: none;
  color: #f78019;
  font-size: 16px;
}
</style>
<style lang="less" scoped>
.login-wrapper {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  .content-wrapper {
    flex: 1;
    padding: 30px 30px 0 30px;
    .content {
      padding: 40px 32px;
      background: #fff;
      .content-head {
        display: flex;
        align-items: flex-start;
        border-radius: 16px;
        .label {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 92px;
          height: 34px;
          margin-top: 7px;
          background: linear-gradient(90deg, #fe8124 0%, #ff4c11 100%);
          border-radius: 17px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
        .text {
          margin-left: 12px;
          font-size: 34px;
          text-align: left;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ff933b;
          line-height: 48px;
        }
      }
      .time {
        margin-top: 40px;
        .time-text {
          display: flex;
          align-content: center;
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 45px;
          .label {
            color: #f55029;
          }
        }
        .list {
          margin-top: 16px;
          display: flex;
          align-items: center;
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 175px;
            height: 65px;
            border: 1px solid #f5f5f5;
            background: #f5f5f5;
            border-radius: 8px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            &.active {
              color: #f78019;
              background: #fff2dc;
              border: 1px solid #f78019;
            }
          }
          .item + .item {
            margin-left: 30px;
          }
        }
      }
      .form {
        .form-item {
          margin-top: 20px;
        }
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    height: 120px;
    background: #fff;
    .left {
      display: flex;
      align-items: center;
      .text {
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .price {
        display: flex;
        align-items: baseline;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff5330;
        .text {
          font-size: 38px;
          color: #ff5330;
        }
      }
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 260px;
      height: 90px;
      background: #ff933b;
      border-radius: 45px;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .buy-success {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
